import React from "react";
import { Marquee } from "./primitives";
import FAQ from "./FAQ";
import HookSection from "./sections/HookSection";
import VorstellenSection from "./sections/VorstellenSection";
import SoundsCrazySection from "./sections/SoundsCrazySection";
import SpielregelnSection from "./sections/SpielregelnSection";
import WirklichSection from "./sections/WirklichSection";
import EigenesSpielSection from "./sections/EigenesSpielSection";
import ModuleSection from "./sections/ModuleSection";
import AlleineSection from "./sections/AlleineSection";
import BioSection from "./sections/BioSection";
import AblaufSection from "./sections/AblaufSection";
import InvestmentSection from "./sections/InvestmentSection";
import BoniSection from "./sections/BoniSection";
import FuerWenSection from "./sections/FuerWenSection";
import EntscheidungSection from "./sections/EntscheidungSection";
import ClosingSection from "./sections/ClosingSection";
import SiteFooter from "./sections/SiteFooter";

export default function SalesPage() {
  return (
    <main className="overflow-x-clip bg-paper">
      <HookSection />
      <VorstellenSection />
      <SoundsCrazySection />
      <Marquee dark />
      <SpielregelnSection />
      <WirklichSection />
      <EigenesSpielSection />
      <ModuleSection />
      <AlleineSection />
      <BioSection />
      <AblaufSection />
      <InvestmentSection />
      <BoniSection />
      <FuerWenSection />
      <EntscheidungSection />
      <FAQ />
      <ClosingSection />
      <SiteFooter />
    </main>
  );
}
